export enum SearchLandingType {
  NewsTopics = "news-newstopics",
  ThinkTopics = "think-articletopics",
  ThinkAuthors = "think-articleauthors",
}
